var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"toolbarBtn",class:{active: _vm.active},attrs:{"type":"button"},on:{"mousedown":function($event){$event.preventDefault();},"click":_vm.onClick}},[_c('img',{attrs:{"src":require("@/assets/img/CITEditor/bold.svg"),"alt":"bold","title":"bold"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }